import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { usePendingDeploys } from '@/hooks/useDeploys'

export default function DeployToast() {
  const { data: pending } = usePendingDeploys()
  const nav = useNavigate()
  const prevCount = useRef(0)
  const toastRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const count = pending?.length ?? 0
    if (count > prevCount.current && count > 0) {
      // New pending deploy arrived — show toast
      if (toastRef.current) {
        toastRef.current.classList.remove('hidden')
        toastRef.current.classList.add('animate-bounce')
        setTimeout(() => {
          toastRef.current?.classList.remove('animate-bounce')
        }, 1000)
        // Auto-hide after 10s
        setTimeout(() => {
          toastRef.current?.classList.add('hidden')
        }, 10000)
      }
    }
    prevCount.current = count
  }, [pending])

  const latest = pending?.[0]
  if (!latest) return null

  return (
    <div
      ref={toastRef}
      className="hidden fixed bottom-4 right-4 z-50 bg-warning text-warning-foreground px-4 py-3 rounded-lg shadow-lg cursor-pointer max-w-sm"
      onClick={() => {
        toastRef.current?.classList.add('hidden')
        nav('/deploy')
      }}
    >
      <div className="font-semibold text-sm">New build ready</div>
      <div className="text-xs mt-0.5 opacity-90">
        {latest.service_name || `Service #${latest.service_id}`}
        {latest.commit_hash && (
          <span className="ml-1 font-mono">{latest.commit_hash.slice(0, 7)}</span>
        )}
      </div>
      <div className="text-xs mt-1 opacity-75">Click to review</div>
    </div>
  )
}
